import { fetchWithAuth } from './utils';

export const fetchLabel = async () => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/label/get`);

    try {
        const response = await fetchWithAuth(url, {
            method: 'GET',
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();

        return data;
    } catch (error) {
        console.error('Failed to fetch device list:', error);
        throw error;
    }
};